import { Injectable } from "@angular/core";
import {AmdocsAppsyncClientService} from 'amdocs-core-package';
import {Observable, of} from 'rxjs';
import {catchError, mergeMap} from 'rxjs/operators';
import { CONSTANTS } from "../constants";

@Injectable({
  providedIn: 'root'  // This ensures the service is a singleton
})
export class MarkUnMarkFavouriteProductLine {
    constructor( 
      private appSyncClient: AmdocsAppsyncClientService) {
    }

     markUnmarkFavourite(input,sessionContextInput?): Observable<any> {
        const favQuery = `mutation MarkUnMarkFavouriteProductLineMutation($saveFaouriteProdcutLineInput: SaveFaouriteProdcutLineInput!, $sessionContextInput:SessionContextInput  ) {
          markUnMarkFavouriteProductLine(saveFaouriteProdcutLineInput: $saveFaouriteProdcutLineInput, sessionContextInput: $sessionContextInput) {
            isSuccess
            message
          }
        }`;
       const param = {
        saveFaouriteProdcutLineInput: input.saveFaouriteProdcutLineInput,
        sessionContextInput: sessionContextInput
      };
          return this.appSyncClient.call(favQuery, 'MarkUnMarkFavouriteProductLineMutation', param).pipe(
            mergeMap( (res: any): Observable<any> => {
              return of(res);
            }),
            catchError( err => {
              console.log(err);
              return of({error: err});
            })
        );
    }

    sortMarkedFavProducts(data) {
      return data.sort((a, b) => a.name.localeCompare(b.name));
    }

    getFavouriteProductList(sessionContextInput?): Observable<any> {
     const getFavList = `query GetMyFavouriteProductLineList($sessionContextInput: SessionContextInput!) {
      getMyFavouriteProductLineList(sessionContextInput: $sessionContextInput) {
        SysID
        name
        isMarkFavourite
      }
       }`;

       const params = {
        sessionContextInput: sessionContextInput? sessionContextInput : {}
      };
       
     
       return this.appSyncClient.call(getFavList, 'GetMyFavouriteProductLineList', params).pipe(
      mergeMap((res: any): Observable<any> => {
       if(Boolean(
          res?.getMyFavouriteProductLineList?.length
        )){
          res.getMyFavouriteProductLineList = this.sortMarkedFavProducts(res.getMyFavouriteProductLineList);
          let favouriteset = res?.getMyFavouriteProductLineList;
          if(favouriteset){
         localStorage.setItem(CONSTANTS.STORAGE.markedFavoriteProducts, JSON.stringify(favouriteset));
          }
        }
        return of(res);
      }),
      catchError(err => {
        return of(err);
      })
       )

      }

}